import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, API_BASE, DOMAIN_COLORS } from "@/lib/api";

export default function TestResult() {
  const { reportId } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/test/report/${reportId}`).then((r) => setData(r.data)).catch(() => {}); }, [reportId]);

  if (!data) return <Layout><div className="container-msis py-20">Loading your report…</div></Layout>;
  const report = data.report;
  const top = report.domain_ranking[0];

  return (
    <Layout>
      <section className="container-msis py-12">
        <div className="bg-navy text-white p-8 rounded-md" data-testid="result-hero">
          <div className="overline text-white/60">Your MSIS Report</div>
          <div className="mt-2 font-display font-bold text-3xl tracking-tight">Hi {data.name}, your assessment is complete.</div>
          <div className="mt-5 grid sm:grid-cols-3 gap-6">
            <div><div className="overline text-white/60">Primary Inclination</div><div className="font-display font-bold text-xl mt-1">{top.name}</div></div>
            <div><div className="overline text-white/60">Score</div><div className="font-mono font-bold text-xl mt-1">{top.score.toFixed(2)} / 5.00</div></div>
            <div><div className="overline text-white/60">Inclination</div><div className="font-display font-bold text-xl mt-1">{top.band_name}</div></div>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={`${API_BASE}/test/report/${reportId}/pdf`} target="_blank" rel="noreferrer"
               className="inline-flex items-center gap-2 bg-white text-ink px-5 py-2.5 rounded-md font-medium hover:bg-gold" data-testid="download-pdf-btn">
              Download PDF Report
            </a>
            <Link to="/" className="inline-flex items-center gap-2 border border-white/30 text-white px-5 py-2.5 rounded-md hover:bg-white hover:text-ink">Back to Home</Link>
          </div>
        </div>

        <h2 className="font-display font-bold text-2xl mt-12 mb-4">Domain Ranking</h2>
        <div className="border border-border rounded-md overflow-hidden" data-testid="result-table">
          <table className="w-full text-sm">
            <thead className="bg-subtle text-slate2 text-xs uppercase tracking-wider">
              <tr><th className="text-left p-3">#</th><th className="text-left p-3">Domain</th>
                <th className="text-right p-3">Score</th><th className="text-left p-3">Band</th></tr>
            </thead>
            <tbody>
              {report.domain_ranking.map((d, i) => (
                <tr key={d.code} className="border-t border-border">
                  <td className="p-3 font-mono">{i + 1}</td>
                  <td className="p-3"><span className="font-mono text-xs mr-2" style={{ color: DOMAIN_COLORS[d.code] }}>{d.code}</span>{d.name}</td>
                  <td className="p-3 text-right font-mono font-bold">{d.score.toFixed(2)}</td>
                  <td className="p-3 text-slate2">{d.band_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h2 className="font-display font-bold text-2xl mt-12 mb-4">Detailed Profile</h2>
        <div className="space-y-6">
          {report.domain_ranking.map((d, i) => (
            <article key={d.code} className="border border-border p-6 rounded-md">
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div className="flex items-center gap-3">
                  <span className="font-mono text-xs px-2 py-1 border" style={{ borderColor: DOMAIN_COLORS[d.code] + "55", color: DOMAIN_COLORS[d.code] }}>{d.code}</span>
                  <span className="overline">Rank {i + 1}</span>
                </div>
                <div className="font-mono text-sm">{d.score.toFixed(2)} · {d.band_name}</div>
              </div>
              <h3 className="font-display font-bold text-xl mt-3">{d.name}</h3>
              <p className="text-sm text-slate2 mt-2 leading-relaxed">{d.interpretation}</p>
              <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
                {d.constructs.map((c) => (
                  <div key={c.code} className="bg-white p-4">
                    <div className="flex items-center justify-between">
                      <div className="font-mono text-[11px] text-slate2">{c.code}</div>
                      <div className="font-mono text-sm font-bold">{c.score.toFixed(2)}</div>
                    </div>
                    <div className="font-display font-semibold text-sm mt-1">{c.name}</div>
                    <div className="text-xs text-slate2 mt-1">{c.band_name}</div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </section>
    </Layout>
  );
}
